'use strict';

var defineComponent = require('flightjs').component;
var withAsyncMenu = require('./mixins/async-menu');

module.exports = defineComponent(withAsyncMenu);



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/lib/ui/messages-menu.js
 **/